import { render, staticRenderFns } from "./Manage-Department.vue?vue&type=template&id=2e061b33"
import script from "./Manage-Department.vue?vue&type=script&lang=js"
export * from "./Manage-Department.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports